import React, {Component} from 'react'
import ParkingPassComponent from '../components/ParkingPassComponent'
//import ParkingPassFilterMenuComponent from '../components/ParkingPassFilterMenuComponent'
import FrontOfficeNavMenuComponent from "../components/FrontOfficeNavMenuComponent";

export default class UserMainNavigatorScreen extends Component {

    render() {
        return(
            <div>
                <div className="backoffice">
                    <div className="row">
                        <FrontOfficeNavMenuComponent {...this.props} />
                        <div className="col-md-10 col-md-offset-1">
                            {this.props.children}
                        </div>
                    </div>
                </div>
            </div>

        );
    }
}


// WEBPACK FOOTER //
// ./src/screens/UserMainNavigatorScreen.js